import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@ui/Form";
import NumberInput from "@ui/NumberInput";
import { useMultiStepForm } from "@/hooks";
import { cn } from "@/utils/tailwind";

export const FixedBillingSubform: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();

  return (
    <FormField
      control={form.control}
      name="step3.fixedPrice"
      render={({ field }) => (
        <FormItem className="gap-1 pl-7 sm:px-7">
          <FormControl>
            <div className="space-y-0.5">
              <FormDescription className={cn(disabled && "text-input")}>
                {t("step3.q1_price")}
              </FormDescription>
              <NumberInput
                {...field}
                dataTest="fixed-price-input"
                decimalScale={2}
                isError={Boolean(form.formState.errors.step3?.fixedPrice)}
                className="sm:max-w-[172px]"
                disabled={disabled}
                unit={`${t("zl")}/${t("MWh")}`}
              />
            </div>
          </FormControl>
          <FormMessage data-test="fixed-price-error" />
        </FormItem>
      )}
    />
  );
};
